import script from "./InkAbout.vue?vue&type=script&setup=true&lang=js"
export * from "./InkAbout.vue?vue&type=script&setup=true&lang=js"

import "./InkAbout.vue?vue&type=style&index=0&id=13f49a6c&lang=scss"

const __exports__ = script;

export default __exports__